// import React from 'react'
// import BgImage from '../Images/BgImage.jpg'

// function Home() {
//     return (
//         <div
//             className="relative w-screen h-screen overflow-hidden flex items-center justify-center bg-cover bg-center"
//             style={{ backgroundImage: `url(${BgImage})` }}
//         >
//             <div className="absolute inset-0 bg-black/40" />

//             <div className="relative z-10 text-center text-white px-4">
//                 <h1 className="text-6xl md:text-6xl font-light tracking-widest uppercase mb-4">
//                     Coming Soon
//                 </h1>

//                 <p className="text-s md:text-base tracking-widest uppercase opacity-70">
//                     Site Under Reconstruction
//                 </p>
//             </div>
//         </div>
//     )
// }

// export default Home


// import React, { useEffect, useState } from "react";
// import { motion } from "framer-motion";
// import BgImage from "../Images/BgImage.jpg";

// function Home() {
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         const timer = setTimeout(() => setLoading(false), 2000);
//         return () => clearTimeout(timer);
//     }, []);

//     if (loading) {
//         return (
//             <div className="flex items-center justify-center h-screen bg-black text-white text-2xl">
//                 <motion.div
//                     animate={{ rotate: 360 }}
//                     transition={{ repeat: Infinity, duration: 1.2, ease: "linear" }}
//                     className="w-12 h-12 border-4 border-white border-t-transparent rounded-full"
//                 />
//             </div>
//         );
//     }

//     return (
//         <div
//             className="relative w-screen h-screen overflow-hidden flex flex-col items-center justify-center bg-cover bg-center"
//             style={{ backgroundImage: `url(${BgImage})` }}
//         >
//             <div className="absolute inset-0 bg-black/60" />

//             <motion.div
//                 initial={{ opacity: 0, y: 40 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 1 }}
//                 className="relative z-10 text-center text-white px-4"
//             >
//                 <motion.h1
//                     initial={{ opacity: 0, scale: 0.8 }}
//                     animate={{ opacity: 1, scale: 1 }}
//                     transition={{ duration: 1.2, ease: "easeOut" }}
//                     className="text-5xl md:text-6xl font-extrabold tracking-[0.3em] uppercase mb-4 bg-gradient-to-r from-pink-400 via-purple-400 to-blue-400 text-transparent bg-clip-text"
//                 >
//                     Coming Soon
//                 </motion.h1>

//                 <p className="text-sm md:text-base tracking-[0.3em] uppercase opacity-80 mb-6">
//                     Site Under Reconstruction
//                 </p>
//             </motion.div>

//             <motion.div
//                 initial={{ opacity: 0 }}
//                 animate={{ opacity: 1 }}
//                 transition={{ delay: 1.2, duration: 1 }}
//                 className="relative z-10 mt-8 flex flex-col items-center gap-8"
//             >

//             </motion.div>
//         </div>
//     );
// }

// export default Home;

import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import BgImage from "../Images/BgImage.jpg";
import Logo from "../Images/Logo1.png"; 
import Loader from "../Images/loadingbar2.gif"; 

function Home() {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 2000);
        return () => clearTimeout(timer);
    }, []);

    if (loading) {
        return (
            <div className="flex items-center justify-center h-screen bg-black text-white text-2xl">
                <motion.div
                    animate={{ rotate: 360 }}
                    transition={{ repeat: Infinity, duration: 1.2, ease: "linear" }}
                    className="w-12 h-12 border-4 border-white border-t-transparent rounded-full"
                />
            </div>
        );
    }

    return (
        <div
            className="relative w-screen h-screen overflow-hidden flex flex-col items-center justify-center bg-cover bg-center"
            style={{ backgroundImage: `url(${BgImage})` }}
        >
            <div className="absolute inset-0 bg-black/60" />

            {/* <div >
                <img
                    src={Logo}
                    alt="Logo"
                    // style={{backgroundColor: 'rgba(255,255,255,0.5)', backdropFilter: 'blur'}}
                    className="w-38 md:w-36 lg:w-40 object-contain glassy"
                />
            </div> */}

<br />
<br />

            <motion.div
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1 }}
                className="relative z-10 text-center text-white px-4"
            >
                <motion.h1
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 1.2, ease: "easeOut" }}
                    className="text-5xl md:text-6xl font-extrabold tracking-[0.3em] uppercase mb-4 bg-gradient-to-r from-pink-400 via-purple-400 to-blue-400 text-transparent bg-clip-text"
                >
                    Coming Soon
                </motion.h1>

                <p className="text-sm md:text-base tracking-[0.3em] uppercase opacity-80 mb-6">
                    Site Under Reconstruction
                </p>

                <img src={Loader} alt="Computer man" style={{height: "150px", placeSelf: 'center'}}></img>

                <a href="emailto:Walla@worldwalla.com" class='butn butn__new'><span>Contact Us</span></a>

            </motion.div>

            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 1.2, duration: 1 }}
                className="relative z-10 mt-8 flex flex-col items-center gap-8"
            >
            </motion.div>
        </div>
    );
}

export default Home;
